<template>
    <div>
        <arhslgl-base-header-sec :title="headerParams.title" :slug="headerParams.slug"></arhslgl-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <iframe :style="iframeStyle" @load="load" ref="ifr" id="ifr" class="static-iframe" width="100%"
                    :src="baseApiUrl + 'prins/static/page/' + $route.query.code + '/' + $route.query.page"
                    frameborder="0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
import ArhslglBaseHeaderSec from '@/base_pages/arhslgl/ArhslglBaseHeaderSec.vue';


export default {
    name: "ArhslglStaticPage",
    components: {
        ArhslglBaseHeaderSec,
    },
    data() {
        return {
            iframeStyle: {
                height: '800px',
            },
            loaded: false,
            baseApiUrl: window.env.VUE_APP_API_FP_DEV,
             
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    methods: {
        load: function () {
            this.loaded = true;
        }
    },
    watch: {
        $route() {
            if (this.$route.query.page === 'contact' || this.$route.query.page === 'impresum') {
                this.iframeStyle.height = '440px';
            } else {
                this.iframeStyle.height = '600px';
            }
        }
    },
    mounted() {
        if (this.$route.query.page === 'contact' || this.$route.query.page === 'impresum') {
            this.iframeStyle.height = '440px';
        } else {
            this.iframeStyle.height = '600px';
        }
    },
    computed: {
        headerParams() {
            let extCode;
            let title;
            // TODO Dodati naslove
            console.log(this.$route.query.code);
            switch (this.$route.query.code) {
                case 'SGARHSTARO':
                    title = 'Архива службеног гласника';
                    extCode = 'sgarh';
                    break;
                case 'PGARHSTARO':
                    title = 'Архива просветног гласника';
                    extCode = 'pgarh';
                    break;
                case 'SLARHSTARO':
                    title = 'Архива службеног листа';
                    extCode = 'slarh';
                    break;
                case 'MUARHSTARO':
                    title = 'Архива ратификованих међународних уговора и других аката';
                    extCode = 'muarh';
                    break;
                default:
                // code block
            }
            return { title: title, slug: extCode }
        }
    },
    beforeCreate: function () {
        document.body.className = 'color_arhslgl';
    }
}
</script>

<style scoped></style>
